"use strict";
exports.__esModule = true;
exports.Nodes = void 0;
var isRoot = function (node) { return !node.parentUuid; };
var areEqual = function (nodeA, nodeB) { return nodeA.uuid === nodeB.uuid; };
exports.Nodes = {
    isRoot: isRoot,
    areEqual: areEqual
};
//# sourceMappingURL=nodes.js.map